import React, {useState, useEffect, useMemo, useCallback} from "react";
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import classes from './SecondSSID.css';
import Box from '../../hoc/Box/Box';
import * as actions from '../../store/actions/index';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import Spinner from '../../components/UI/Spinner/Spinner';
import { FaInfoCircle, FaCheckCircle, FaEye, FaEyeSlash } from 'react-icons/fa';
import Switch from '../../components/UI/Switch/Switch';
import Modal from '../../components/UI/Modal/Modal';
import Error from '../../components/UI/Error/Error';
import Success from '../../components/UI/Success/Success';
import Confirm from "../../components/UI/Confirm/Confirm";
import { isEmpty } from "lodash";


const SecondSSID = (props) => {
  const [ssidChecked, setSsidChecked] = useState(props.secondSsid?.secondSsidNetwork?.enable ?? false);
  const [enableSSIDConfigure, setEnableSSIDConfigure] = useState(false);
  const [ssidBroadcast, setSsidBroadcast] = useState(props.secondSsid?.secondSsidNetwork?.ssidBroadcast ?? false);
  const [isInvalidSSIDPassword, setIsInvalidSSIDPassword] = useState(false);
  const [isInvalidSSID, setisInvalidSSID] = useState(false);
  const [showSSIDPassword, setShowSSIDPassword] = useState(false);
  const [ssidName, setSsidName] = useState(props.secondSsid?.secondSsidNetwork?.ssid || "");
  const [ssidPassword, setSsidPassword]= useState(props.secondSsid?.secondSsidNetwork?.encryptionKey || "");
  const [ssidEnable, setSsidEnable] = useState(true);
  const [editForm, setEditForm] = useState(false);
  const [loader, setLoader] = useState(false);
  const [showTooltip, setShowToolTip] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [action, setAction] = useState(null);
  const [result, setResult] = useState('');
  const isMobile = window.innerWidth <= 768;
 
  // useEffect(() => {
  //    if (
  //     props.location &&
  //     props.location.hash === '#secondSSIDSection'
  //   ) {
  //     const timer = setTimeout(() => {
  //       let elem = document.getElementById(props.location.hash.slice(1));
  //         if (elem) {
  //           elem.scrollIntoView({ 
  //             behavior: 'smooth',
  //             block: 'start'
  //           });
  //         }
  //       }, 300);
  //       return () => clearTimeout(timer);
  //     }else{
  //       return;
  //     }
  // },[props.location.hash])


  useEffect(() => {
    setSsidChecked(props.secondSsid?.secondSsidNetwork?.enable);
  },[props.secondSsid?.secondSsidNetwork?.enable])

  useEffect(() => {
    if(props.secondSsid?.secondSsidNetwork){
      if(props.secondSsid?.secondSsidNetwork?.ssid){
        setSsidName(props.secondSsid?.secondSsidNetwork?.ssid);
      }
      if(props.secondSsid?.secondSsidNetwork?.encryptionKey){
        setSsidPassword(props.secondSsid?.secondSsidNetwork?.encryptionKey);
      }

    } if(props.secondSsid?.secondSsidNetwork?.ssidBroadcast){
        setSsidBroadcast(props.secondSsid?.secondSsidNetwork?.ssidBroadcast);
      }
  },[props.secondSsid?.secondSsidNetwork])

  useEffect(() => {
    if(props.secondSsidNetworkSuccess || props.secondSsidNetworkFail){
      setLoader(false);
    }

},[props.secondSsidNetworkSuccess, props.secondSsidNetworkFail])

const updateFormData = () => {
  setSsidName(props.secondSsid?.secondSsidNetwork?.ssid || '');
  setSsidPassword(props.secondSsid?.secondSsidNetwork?.encryptionKey || '');
  setSsidBroadcast(props.secondSsid?.secondSsidNetwork?.ssidBroadcast);
}

const { secondSsidNetwork, secondSsidNetworkFail, secondSsidNetworkLoading, secondSsidFailureMesssage } = {...props?.secondSsid};
const isConfigured = !!Object.keys(secondSsidNetwork || {}).length
const ssidMessageIcon =  props.page === 'network' && isConfigured ? (<FaCheckCircle color="green" size={24} style={{ marginRight: '5px', marginLeft: '5px', marginTop: '10px' }} />)  : (<FaInfoCircle color="#38a9f9" size={24} style={{ marginRight: '5px', marginLeft: '5px', marginTop: '10px' }} />)
const ssidDetailedViewLink = props.page === 'network' ? (isConfigured ? (<span id = 'SecondSSIDManage' className={classes.viewLogLink} onClick={()=>{ setEnableSSIDConfigure(true); setEditForm(true); updateFormData()}} >Manage</span>) : (<span id = 'SecondSSIDConfigure' className={classes.viewLogLink} onClick={()=>{setEnableSSIDConfigure(true)}}>Configure</span>)) : (<span className={classes.viewLogLink}><Link to={{ pathname: '/network',  hash:'#secondSSIDSection' }} href='/#secondSSIDSection' >View</Link></span>);
const ssidDetailedViewLinkMobile = props.page === 'network' ?
                              (isConfigured ?
                                (<span id = 'SecondSSIDManage' className={`${classes.viewLogLink} ${classes.linkDisabled}`} >Manage</span>) 
                                : (<span id = 'SecondSSIDConfigure' className={`${classes.viewLogLink} ${classes.linkDisabled}`} >Configure</span>)) 
                                : (<span className={classes.viewLogLink}><Link to={{ pathname: '/network', hash:'#secondSSIDSection' }} href='/#secondSSIDSection'>View</Link></span>);

const configuredMessage = (<div style={{ display:'flex', flexDirection:'row', justifyContent:'space-between', gap:'1.5rem' }}>
<div id = 'SecondSSIDName' ><b>Guest WiFi Name </b>: {secondSsidNetwork?.ssid}</div>
<div id = 'SecondSSIDPassword'><b>Guest WiFi Password</b>: {secondSsidNetwork?.encryptionKey ? Array(secondSsidNetwork?.encryptionKey?.length + 1).join("*") : ""}</div>
</div>)
let ssidStatusMessage = props.page === 'network' && isConfigured ? (<span id='SecondSSIDConfiguredText' className={classes.SecondSSIDText} > Guest WiFi is currently configured </span>) :(<span id='SecondSSIDNotConfiguredText' className={classes.SecondSSIDText} > Guest WiFi is currently not configured </span>);
ssidStatusMessage = props.page !== 'network' && isConfigured ? configuredMessage  : ssidStatusMessage;
const ssidErrorMessage = <span style={{marginTop: '10px'}} ><strong>There was an error Retreiving the Guest WiFi information</strong></span>;
const ssidErrorMessageIcon = <FaInfoCircle color="red" size={24} style={{ marginRight: '5px', marginLeft: '5px', marginTop: '10px' }} />
const secondSSIDMessage = loader ? <Spinner /> : (


    <div className={classes.secondSSIDMessage}>
        <div className={classes.TitleArea}>
        <div className={classes.TitleLeft} style={{ justifyContent: 'flex-start' }}>
          <div style={{ display:'flex', flexDirection:'row' }}>

          {secondSsidNetworkFail && secondSsidFailureMesssage === '' ? <>
          {ssidErrorMessageIcon}
          {ssidErrorMessage}
          </> : <>
          {props.page !== 'network' && isConfigured ? null :ssidMessageIcon}
          {ssidStatusMessage}
          </>}
          </div>
        </div>
        <div className={[classes.TitleRight, classes.showDesktop].join(' , ')} style={{ justifyContent: 'flex-end', paddingRight:'5px' }}>
          {ssidDetailedViewLink}
        </div>
        <div className={[classes.TitleRight, classes.showMobile].join(' , ')} style={{ justifyContent: 'flex-end', paddingRight:'5px' }}>
          {ssidDetailedViewLinkMobile}
        </div>

        {/* <div className={classes.showMobile}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex' }}>
              {ssidMessageIcon}
              {ssidStatusMessage}
            </div>
          </div>
          {ssidDetailedViewLink}
        </div> */}
      </div>
    </div>
   );
  const secondSSIDStatusValue = secondSsidNetwork?.enable ? 'ON' : 'OFF';
  const secondSSIDStatusColor = secondSSIDStatusValue === 'OFF' ? "#ffbfc2" : '#c2ffbf';

  const secondSSIDStatus = (
    <span id = 'secondSSIDStatus' style={{
      maxWidth: 200,
      padding: 8,
      marginTop: 0,
      marginBottom: 20,
      marginLeft: 20,
      backgroundColor: secondSSIDStatusColor,
    }}>
    Status : {secondSSIDStatusValue}
  </span>
  );

  const confirmModalConfirmHandler = () => {
    setSsidChecked(state => !state);
    if(!!ssidName && !!ssidPassword){
        let info={};
        info = {
            'ssid' : ssidName,
            'ssidPassword': ssidPassword,
            "enable": ssidChecked,
            "ssidBroadcast": ssidBroadcast,
            "method": 'patch'
          }
        props.onSetSecondSsidInfoDetails(info);
        setLoader(true);
        setEnableSSIDConfigure(false);
      }
    closeModal();
  }
  const confirmModalCancelHandler = () => {
    setConfirmModal(false);
    setSsidChecked(state => !state);
  }
  const closeModal= () => {
    setConfirmModal(false);
    setSsidChecked(ssidChecked);
  }

  function guestWifiModalContent() {
    let guestWifiStatus = ssidChecked ? 'enable' : 'disable';

    return (
      <div className={classes.modalContainer}>

        <div id='SSIDWarning' className={classes.title}>This will { guestWifiStatus } the Guest Wifi Network. Current configurations settings will remain.<br /> </div>

        <div id='SSIDConfirm' className={classes.title}>Would you like to proceed?</div>
        <Confirm id = {'GuestWifiConfirm'}
        confirm={confirmModalConfirmHandler}
        cancel={confirmModalCancelHandler}
        cancelButtonLabel="Cancel"
        confirmButtonLabel={ssidChecked ? 'Enable' : 'Disable'}
        hideContent
        deviceGroupConfirmation

        />
      </div>
    )
  }

  const handleToggleGuestWifi = () => {

    setConfirmModal(true);
    setSsidChecked(state => !state);
  }

  function secondSSIDSwitch() {
     return (
        <Switch
        id = 'SecondSSIDToggle'
        aria-checked={ssidChecked}
        className={classes.desktop_view}
        aria-label="Toggle Second SSID"
        onChange={handleToggleGuestWifi}
        checked={ssidChecked}
        disabled={!isConfigured}
      />
    )
  };

  const  handlePasswordChange = (e) => {
    let myValue = e.target.value;
    let res;
    res = myValue.match('^[^<>$`\\\\^&;"\']+$');
    if (res == null) {
      setIsInvalidSSIDPassword(true);
    } else if (/\s+$/.test(myValue) || /^\s/.test(myValue) || /\s{2,}/g.test(myValue)) {
      setIsInvalidSSIDPassword(true);
    } else {
      setIsInvalidSSIDPassword(false);
    }

    setSsidPassword(myValue);

  }

  const handleSSIDNameChange = (e) => {
    let myValue = e.target.value;
    let res;
    res = myValue.match('^[^<>$`\\\\^&;"]+$');
    if (res == null) {
      setisInvalidSSID(true);
    } else if (/\s+$/.test(myValue) || /^\s/.test(myValue) || /\s{2,}/g.test(myValue) || (myValue.toLowerCase() === "spectrum mobile")) {
      setisInvalidSSID(true);
    }else {
      setisInvalidSSID(false);
    }
    setSsidName(myValue);
  };
  function configureSecondSSID(){

    const resetForm = () => {
      setIsInvalidSSIDPassword(false);
      setShowSSIDPassword(false);
      setisInvalidSSID(false);
      setSsidName('');
      setSsidPassword('');
      // setSsidChecked(false);
    }
    const addSSIDFormHandler = () => {
      let info={};
       info = editForm ? {
        'ssid' : ssidName,
        'ssidPassword': ssidPassword,
        "enable": ssidEnable,
        "ssidBroadcast": ssidBroadcast,
        "method": 'patch'
      } : {
        'ssid' : ssidName,
        'ssidPassword': ssidPassword,
        "enable": ssidEnable,
        "ssidBroadcast": ssidBroadcast
      }
      props.onSetSecondSsidInfoDetails(info);
      setLoader(true);
      setEnableSSIDConfigure(false);
      resetForm();
      setSsidChecked(true);
    }

    const [showConfirmationModal, setShowConfirmationModal] = useState(false);

    const handleDeleteSsid = () => {
      setShowConfirmationModal(true)
    }

    const onConfirmation = () => {
      setShowConfirmationModal(false)
      resetForm();
      setEnableSSIDConfigure(false)
      props.onDeleteSecondSsidInfoDetails();
      setEditForm(false);
    }

    const onCancel = () => {
      setShowConfirmationModal(false);
      setEnableSSIDConfigure(false);
      setEditForm(true);
    }

    const confirmationModal = (
      <Modal
        show={showConfirmationModal}
      >
        <div>
          <h1 id = 'SecondSSIDDelete' className={classes.deleteConfirmationModalTitle}>Delete Guest WiFi</h1>
          <div id = 'SecondSSIDDeleteMsg' >This will permanently delete the Guest WiFi and schedules. Do you really want to proceed?</div>
          <div className={classes.ButtonRow}>
            <button id = 'SecondSSIDProceed' className={classes.Button} onClick={onConfirmation}>Proceed</button>
            <button id = 'SecondSSIDCancel' className={classes.CancelButton} onClick={onCancel}>Cancel</button>
          </div>
        </div>
    </Modal>
    )

    let onOff = (<div >
        <Switch
          id="NetworkVisbilityEnableToggle"
          aria-checked={true}
          aria-label='network enable'
          onText='ON'
          offText='OFF'
          onChange={() => { setSsidBroadcast(!ssidBroadcast) }}
          checked= {ssidBroadcast}
          style={{marginTop: '10px'}}
        />
      </div>);
    return (<React.Fragment>
      <div className={classes.ConfigureSSID}>
      <div className={classes.subHeader}>
          <strong>Guest WiFi </strong>
          <button id= 'SecondSSIDelete' disabled={isEmpty(props.secondSsid.secondSsidNetwork)} onClick={handleDeleteSsid} className={classes.deleteLink}>Delete Guest WiFi</button>
        </div>
        {confirmationModal}

        <div className={classes.ConfigureSSIDBody}>
          <Box>
            <div
              id="configureSecondSSIDText"
              style={{  color: '#000', fontSize: 'small' }}
            >
              SSID Name
            </div>
            <div id = "SecondSsidToggle" className={[classes.desktop_view, classes.switchclass].join(' ')} />
            <div
              className={classes.Input}
              // style={{ padding: '2px 20px 20px 0px' }}
            >
              <input
                id="ssidNameTextbox"
                aria-label="SSID name"
                type="text"
                className={classes.InputElement}
                value={ssidName}
                placeholder='Create SSID Name'
                minLength="3"
                maxLength="32"
                max={32}
                required
                onChange={handleSSIDNameChange}
              />
              <div id = 'SecondSSIDNameCharlen' className={classes.Helper}>3-32 characters</div>
              {/* <div className={classes.Spacer}></div> */}
            </div>
            { (ssidName.toLowerCase() === "spectrum mobile") ?
              <div
                style={{
                      color: 'red',
                      fontSize: 12,
                      display: 'block',
                      paddingLeft: 10,
                }}
              >
                { `Invalid Value. SSID may not be '${ssidName}'`}
              </div> : ''
            }
            {!(ssidName.toLowerCase() === "spectrum mobile") ?
            <div
              id="ssidNameErrorMsg"
              style={
                isInvalidSSID
                  ? {
                    color: 'red',
                    fontSize: 12,
                    display: 'block',
                    paddingLeft: 10,
                  }
                  : { display: 'none' }
              }
            >
              Space is only allowed in between the characters. The following
              characters are not allowed $ {'<'} {'>'} ` \ ^ & ; " '
            </div> : ''
          }

          </Box>
          <Box>
            <div
              id="configureSecondSSIDPasswordText"
              style={{ color: '#000', fontSize: 'small' }}
            >
              Password
            </div>
            <div
              className={classes.Input}
              style={{ padding: '2px 20px 20px 0px' }}
            >
              <input
                id="ssidPasswordTextbox"
                aria-label="SSID password"
                type= { showSSIDPassword ? "text": "password" }
                className={classes.InputElement}
                minLength="8"
                maxLength="29"
                required
                value={ssidPassword}
                placeholder='Create New Password'
                onChange={handlePasswordChange}
              />
               {!showSSIDPassword ?
               <FaEyeSlash id = 'SecondSSIDEye' color="#38a9f9" size={20} style={{marginLeft: "-35px", cursor: 'pointer'}} onClick={() => { setShowSSIDPassword(!showSSIDPassword)}} /> :
              <FaEye id = 'SecondSSIDEye' color="#38a9f9" size={20} style={{marginLeft: "-35px", cursor: 'pointer'}} onClick={() => { setShowSSIDPassword(!showSSIDPassword)}} />
              }
            </div>
            <div id = 'SecondSSIDPassCharlen' className={classes.passwordHelper}>8-29 characters</div>
            <div
              id="ssidPasswordErrorMsg"
              style={
                isInvalidSSIDPassword
                  ? {
                    color: 'red',
                    fontSize: 12,
                    display: 'block',
                    paddingLeft: 2,
                  }
                  : { display: 'none' }
              }
            >
              Space is only allowed in between the characters. The following
              characters are not allowed $ {'<'} {'>'} ` \ ^ & ; " '
            </div>
          </Box>
            <Box>
              <div className={classes.BodyRow} style={{ display: 'flex' }}>
                <div
                  id="secondSSIDVisibility"
                  style={{


                    display: 'flex',color: '#000', fontSize: 'small'
                  }}
                >
                  Network Visibility
                </div>
                <div style={{ position: "relative"}}>
                  <FaInfoCircle
                   id = 'SecondSSIDInfoTool' color="#38a9f9" size={15} style={{ marginLeft: '1px', marginTop: '3px' }}
                  onMouseOver={() => {
                    setShowToolTip(state => !state)
                  }}
                  onMouseOut={() => {
                    setShowToolTip(false)
                  }}
                  />
                  {showTooltip && <div id = 'SecondSSIDToolTipText' style={{position: "absolute", top: "-21px", left: "15px", border: "1px solid black", whiteSpace: "nowrap", padding: "0.25rem",fontSize:"12px"}}> This allows the network to be hidden or visible</div>}
                </div>

              </div>
            </Box>
            {onOff}
          <Box>
            <div className={classes.BodyRow}>
              <div style={{ display: 'flex' }}>
                <div>
                  <button
                    disabled={
                      isFormDisabled()
                    }
                    id="ConfigureSSIDSaveButton"
                    className={classes.Button}
                    onClick={() => {addSSIDFormHandler()}}
                    btnType="Success"
                  >
                    Save
                  </button>
                  <button
                  id="ConfigureSSIDCancelButton"
                    className={classes.CancelButton}
                    onClick={() => { setEnableSSIDConfigure(); !editForm && resetForm() }}
                  >
                  {'Cancel'}
                </button>
                </div>
              </div>
            </div>
          </Box>
        </div>
      </div>
    </React.Fragment>)
  }

  const successErrorResetHandlerForSecondSsidForm = () => {
    props.onResetSecondSsidErrorSuccess();
  };

  const isFormDisabled = () => {
    return (isInvalidSSID || isInvalidSSIDPassword ) ||
    (!ssidName?.length || !ssidPassword?.length) ||
    !(ssidName?.length >= 3 && ssidPassword?.length >= 8) ||
     (isConfigured && (
      ssidName === props.secondSsid?.secondSsidNetwork?.ssid &&
      ssidPassword === props.secondSsid?.secondSsidNetwork?.encryptionKey &&
      ssidBroadcast === props.secondSsid?.secondSsidNetwork?.ssidBroadcast

    ))
  }

  const errorDetails =  {
      status : props.secondSsidDeleteFailureMesssage || props.secondSsidFailureMesssage,
      message: props.secondSsidDeleteFailureMesssage
              ? props.secondSsidDeleteFailureMesssage
              : props.secondSsidFailureMesssage ? props.secondSsidFailureMesssage :'There was an error Retreiving the second SSID information'
    }


  return (
    <Box>
         <div className={classes.SecondSSID} id='secondSSIDSection' style={{ scrollMarginTop: '80px'}}>
         {secondSsidNetworkLoading ? <Spinner /> :
         <>
           <div className={classes.TitleArea}>
             <div className={classes.TitleLeft}>
             <h3 id='SecondSSIDText' className={classes.ComponentTitle}>Guest WiFi {(isConfigured &&  props.page !== 'network') && <span id= 'SecondSSIDBroadcast'>{secondSsidNetwork?.ssidBroadcast ? ": Visible": ": Hidden"}</span>}</h3>
             </div>
             {(!props.secondSsidNetworkLoading || !loader) &&
            (
             <div className={classes.TitleRight} title= {!isConfigured ? "The Guest Wifi Network has not been configured. Click the configure button to create a network." : ''}>
              {props?.page === 'network' ? secondSSIDSwitch() : secondSSIDStatus}
             </div>)}
           </div>
           {/* {(props.secondSsidNetworkLoading || loader) ? <Spinner /> : */}
           {secondSSIDMessage}
           </>}
         </div>
          <Modal show={confirmModal} modalClosed={closeModal} >
            { guestWifiModalContent() }
          </Modal>
          <Modal
            show={enableSSIDConfigure}
          >
           { configureSecondSSID() }
          </Modal>
          <Modal
            show={props.secondSsidNetworkSuccess}
            modalClosed={
              successErrorResetHandlerForSecondSsidForm
            }
          >
            <Success id={'SecondSsidNetworkSuccess'} message={props.secondSsidNetworkSuccessMessage}  />
          </Modal>

          <Modal
            show={errorDetails.status}
            modalClosed={
              successErrorResetHandlerForSecondSsidForm
            }
          >
            <Error id={'SecondSsidError'} showOldView= {false} customMsg={errorDetails.message}/>
          </Modal>

       </Box>
  );

}

const mapStateToProps = (state) => ({
	secondSsid : state.secondSsid,
  secondSsidNetworkSuccess: state.secondSsid.secondSsidNetworkSuccess,
  secondSsidNetworkFail: state.secondSsid.secondSsidNetworkFail,
  secondSsidFailureMesssage: state.secondSsid.secondSsidFailureMesssage,
  secondSsidNetworkLoading: state.secondSsid.secondSsidNetworkLoading,
  secondSsidNetworkSuccessMessage: state.secondSsid.secondSsidNetworkSuccessMessage,
  secondSsidDeleteFailureMesssage: state.secondSsid.secondSsidDeleteFailureMesssage
});

const mapDispatchToProps = (dispatch) => ({
	onSetSecondSsidInfoDetails: (info) => {
    dispatch(actions.addSecondSsidInfoDetails(info));
  },
  onResetSecondSsidErrorSuccess: () => {
    dispatch(actions.resetSecondSsidErrorSuccess());
  },
  onDeleteSecondSsidInfoDetails: () => {
    dispatch(actions.deleteSecondSsidInfoDetails());
  },
  getSecondSsid: () =>  dispatch(actions.getSecondSsid())

});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SecondSSID));